module.exports = __webpack_public_path__ + "static/media/card-profile1.d00bddf3.jpg";